import { createSlice } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { persistReducer } from "redux-persist";

// Persist configuration
const persistConfig = {
    key: "user", // the key for the persisted slice in storage
    storage,
    whitelist: ["userDetails", "updateSessionInfo"], // Only persist userDetails
    version: 1,
};

//sample data for user
//{
// 	"accountId": 917504,
// 	"sessionId": "bad1ee03dd9cbe03daec0dbb2fc7cc81",
// 	"mobileNo": "9910010022",
// 	"centreDetails": {
// 		"centreId": 1,
// 		"cityId": 1,
// 		"stateCode": "DL",
// 	},
// 	"addressDetails": {
// 		"pincode": 201301,
// 		"addressGuid": "61aca13e-8238-11ef-bdb6-0ab1c132d6a1",
//      "address" : "Sector 62, Noida"
// 	},
// 	"cartDetails": {
// 		"homeCartId": 2
// 	},
// 	"ipAddress": "1.1.1.1"
// }

const UserSlice = createSlice({
    name: "user",
    initialState: {
        userInfo: {}, // Create a `userInfo` object to store user details separately
    },
    reducers: {
        userDetails: (state, action) => {
            // Update only the `userInfo` part of the state
            state.userInfo = action.payload || state.userInfo;
        },

        logout: (state) => {
            state.userInfo = {};
        },

        // just update centreDetails, addressDetails, cartDetails
        updateSessionInfo: (state, action) => {
            const centreDetails = action.payload.centreDetails;
            const addressDetails = action.payload.addressDetails;
            const cartDetails = action.payload.cartDetails;

            state.userInfo = {
                ...state.userInfo,
                centreDetails,
                addressDetails,
                cartDetails,
            };
        },

        updatePartialSessionInfo: (state, action) => {
            state.userInfo = {
                ...state.userInfo,
                ...action.payload,
            };
        },
    },
});

export const {
    userDetails,
    updateSessionInfo,
    updatePartialSessionInfo,
    logout,
} = UserSlice.actions;
// Wrap the UserReducer with persistReducer
const persistedUserReducer = persistReducer(persistConfig, UserSlice.reducer);

export const UserReducer = persistedUserReducer;
